/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author ILya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { IMSOptionItemProps, IMultiSelectProps } from '@components/common/MultiSelect/MultiSelect';

const PATTERN_FOR_SEPARATORS = new RegExp('[,.; ]+');
const PATTERN_FOR_SPLITTING = new RegExp('([^,.; ]+)[,.; ]*');

export const filterMsisdnInputHandler = (isMultiSearchEnabled: boolean, maxLength?: number): IMultiSelectProps['filterInputHandlerCallback'] => {

    if (!isMultiSearchEnabled || !maxLength) return undefined;

    return (value) => {
        let searchValue = value;

        /* Фильтрация по максимально допустимому кол-ву символов */
        if (searchValue.length > maxLength) {
            searchValue = searchValue.substring(0, maxLength);
        }

        // Если в поиске есть спец символы, то поиск ведется по нескольким абонентам
        if (searchValue.toString().match(PATTERN_FOR_SEPARATORS)) {
            const msisdns = searchValue.toString().split(PATTERN_FOR_SPLITTING)
                ?.reduce((msisdnList: string[], rawMsisdn: string) => {
                    const msisdn = rawMsisdn.replace(/[+()-]/g, '')
                    // Если номер валидный
                    if (msisdn.match('^[7|8][0-9]{10}$') || msisdn.match('^[0-9]{10}$')) {
                        // Приведение номера до стандартного представления xxx-xxx-xx-xx
                        msisdnList.push(msisdn.substring(msisdn.length - 10));
                    }
                    return msisdnList;
                }, []) ?? [];
            return (msisdn: IMSOptionItemProps) => msisdns.includes(msisdn.value.toString());
        } else {
            // дефолтная сортировка - поиск по одному абонента
            searchValue = searchValue
                // спец символы
                .replace(/[+()-]/g, '')
                .replace(/^[7|8]/g, '')

            return (msisdn: IMSOptionItemProps) => msisdn.label.toLowerCase().includes(searchValue.toLowerCase());
        }
    };
};
